<template>
    <div>
        <div>
            <div id="post-module" class="post-module">
                <div class="bbt-subtab bbt-clearfix" style="margin-bottom:15px;">
                    <el-button type="danger" size="mini" round v-if="showApplyPost == 1" @click="open(false)">申请发帖权限</el-button>
                    <el-button type="info" size="mini" round v-else-if="showApplyPost == 2">已申请发帖权限</el-button>
                    <el-button type="danger" size="mini" round v-if="showApplyComment == 1" @click="open(true)">申请评论权限</el-button>
                    <el-button type="info" size="mini" round v-else-if="showApplyComment == 2">已申请评论权限</el-button>
                    <!-- <ul class="bbt-subtab__menu bbt-clearfix down" v-else>
                        <li class="active">发帖</li>
                        <li>回帖</li>
                    </ul> -->
                    <SendPost :direction="direction" :showApplyPost="showApplyPost" />
                </div>
                <div v-if="postList.length == 0">
                    <div class="post-moudle__release">
                        <div class="empty-data">暂无数据</div>
                    </div>
                </div>
                <div v-else>
                    <el-row v-for="(item, index) in postList" :key="item.id">
                        <transition name="fade">
                            <el-card class="box-card" v-if="postShow[index]">
                                <div slot="header" class="clearfix">
                                    <span class="postTitle">{{ item.title }}</span>
                                    
                                    <div style="float: right; padding: 3px 0" class="postOperation">
                                        <el-dropdown trigger="click" @command="delPost">
                                            <span class="el-dropdown-link">
                                                <i class="el-icon-more"></i>
                                            </span>
                                            <el-dropdown-menu slot="dropdown">
                                                <el-dropdown-item icon="el-icon-delete" :command="item.id">删除</el-dropdown-item>
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                    </div>

                                    <!-- <span style="float: right; padding: 3px 0;margin-right:10px;" class="postOperation" @click="checkComment(item.id)"><i class="el-icon-chat-dot-round"></i></span> -->
                                    
                                    <el-dialog title="回复列表" :visible.sync="dialogTableVisible">
                                        <ul class="comment-list" v-if="commentList.length > 0">
                                            <li class="comment" v-for="(item, index) in commentList" :key="item.topic.id">
                                                <div class="comment__thumb">
                                                    <img :src="item.topic.thumbImg == 'default.jpg'? `${publicPath}` + 'default/avatar.webp' : item.topic.thumbImg" class="bbt-avatar bbt-avatar--sm">
                                                </div>
                                                <div class="comment__body">
                                                    <div class="comment__title">
                                                        {{item.topic.nickname}}
                                                        <span class="comment__time">
                                                        {{ $filters.formatDate(item.topic.createTime) }}
                                                        </span>
                                                    </div>
                                                    <div class="comment__content">
                                                        {{item.topic.content}}
                                                    </div>
                                                    <div class="comment__action">
                                                        <a href="javascript:;" class="comment__action-item link-dark-minor comment_praise" @click="commentPraise">
                                                            <i class="layui-icon layui-icon-praise"></i> {{item.topic.likeNum}} 赞
                                                        </a>
                                                        <a href="javascript:;" class="comment__action-item link-dark-minor comment_reply" @click="commentReply">
                                                            <i class="layui-icon layui-icon-reply-fill"></i> {{item.topic.replyNum}} 回复
                                                        </a>
                                                        <a href="javascript:;" class="comment__action-item link-dark-minor comment_tread" @click="commentTread">
                                                            <i class="layui-icon layui-icon-tread"></i> {{item.topic.isReply}} 踩
                                                        </a>
                                                    </div>
                                                    <!-- 回复框 -->
                                                    <div class="reply-form" style="display:none;">
                                                        <div class="reply-form__comment-wrap">
                                                            <input id="reply_comment_0" :placeholder="item.topic.content" v-model="replyText" class="reply-form__comment">
                                                        </div>
                                                        <div class="reply-form__action">
                                                            <button class="bbt-btn bbt-btn-link--default" @click="cancelReply">
                                                                取消
                                                            </button>
                                                            <button class="bbt-btn bbt-btn--primary" @click="confirmReply"
                                                                :data-index="index"
                                                                :data-touid="item.topic.fromUid"
                                                                :data-tonickname="item.topic.nickname" 
                                                                :data-replytype="item.topic.topicType" 
                                                                :data-articleid="item.topic.articleId" 
                                                                :data-commentid="item.topic.id">
                                                                回复
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <ul class="comment-list" v-if="item.replays.length > 0">
                                                        <li class="comment" v-for="repItem in item.replays" :key="repItem.replay.id">
                                                            <div class="comment__thumb">
                                                                <img :src="repItem.replay.fromThumbImg" class="bbt-avatar bbt-avatar--sm">
                                                            </div>
                                                            <div class="comment__body">
                                                                <div class="comment__title">
                                                                    {{repItem.replay.fromNickname}}
                                                                    <span class="comment__time">
                                                                    {{repItem.replay.createTime | timeInteval}}
                                                                    </span>
                                                                </div>
                                                                <div class="comment__content">
                                                                    {{repItem.replay.content}}
                                                                </div>
                                                                <div class="comment__action">
                                                                    <a href="javascript:;" class="comment__action-item link-dark-minor comment_praise" @click="commentPraise">
                                                                        <i class="layui-icon layui-icon-praise"></i> {{repItem.replay.likeNum}} 赞
                                                                    </a>
                                                                    <a href="javascript:;" class="comment__action-item link-dark-minor comment_reply" @click="commentReply">
                                                                        <i class="layui-icon layui-icon-reply-fill"></i> {{repItem.replay.replyNum}} 回复
                                                                    </a>
                                                                    <a href="javascript:;" class="comment__action-item link-dark-minor comment_tread" @click="commentTread">
                                                                        <i class="layui-icon layui-icon-tread"></i> {{repItem.replay.isReply}} 踩
                                                                    </a>
                                                                </div>
                                                                <!-- 回复框 -->
                                                                <div class="reply-form" style="display:none;">
                                                                    <div class="reply-form__comment-wrap">
                                                                        <input id="reply_comment_0" :placeholder="repItem.replay.content" v-model="replyText" class="reply-form__comment">
                                                                    </div>
                                                                    <div class="reply-form__action">
                                                                        <button class="bbt-btn bbt-btn-link--default" @click="cancelReply">
                                                                            取消
                                                                        </button>
                                                                        <button class="bbt-btn bbt-btn--primary" @click="confirmReply"
                                                                            :data-touid="repItem.replay.fromUid" 
                                                                            :data-tonickname="repItem.replay.toNickname" 
                                                                            :data-replytype="repItem.replay.replyType" 
                                                                            :data-articleid="item.topic.articleId" 
                                                                            :data-commentid="repItem.replay.id">
                                                                            回复
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>

                                                </div>
                                            </li>
                                        </ul>
                                    </el-dialog>
                                    
                                    <!-- <div style="float: right; padding: 3px 0;margin-right:30px;">
                                        <el-badge :value="12" class="item">
                                            <el-button size="mini">评论</el-button>
                                        </el-badge>
                                    </div>
                                    <div style="float: right; padding: 3px 0;margin-right:20px;">
                                        <el-badge :value="2" class="item" type="warning">
                                            <el-button size="mini">回复</el-button>
                                        </el-badge>
                                    </div> -->
                                </div>
                                <div v-html="item.content" class="postContent">
                                </div>
                            </el-card>
                        </transition>
                    </el-row>
                    
                    <el-row type="flex" justify="center" v-if="hasMoreArticle">
                        <el-col :span="12">
                            <el-button style="width:100%"  @click="loadMoreArticle">查看更多</el-button>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SendPost from '@/post_component/SendPost.vue'

export default {
    name:'UserDetailPost',
    props:{
        serveHost: String
    },
    components:{
        SendPost
    },
    data() {
        return {
            publicPath: process.env.BASE_URL,
            direction:'right',
            pagNo:1,
            showApplyPost:1,
            showApplyComment:1,
            user:{},
            postList:[],
            postShow:[],
            commentList:[],
            hasMoreArticle:true,
            dialogTableVisible:false
        }
    },
    methods: {
        open(p) {
            var _vm = this;
            var promptTitle = '申请发帖权限';
            var authType = 2;
            if(p) {
                promptTitle = '申请评论权限';
                authType = 1;
            }
            this.$prompt(promptTitle, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消'
            // inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
            // inputErrorMessage: '邮箱格式不正确'
            }).then(({ value }) => {
                $.ajax({
                    type:'POST',
                    url: process.env.VUE_APP_URL + "/api/v1/article/apply/comment/auth",
                    data:{
                        authType: authType,
                        reason: value,
                        userId: _vm.user.userid,
                        userName: _vm.user.username
                    },
                    headers:{
                        Authorization:localStorage.getItem('token')
                    },
                    success:function(r) {
                        // console.log(r);
                        if(r.code != "2000000") {
                            if(r.code == '1015008') {
                                if(p) {
                                    _vm.showApplyComment = 2;
                                    _vm.user.commentAuth = 2;
                                } else {
                                    _vm.showApplyPost = 2;
                                    _vm.user.postAuth = 2;
                                }
                                localStorage.setItem('user', JSON.stringify(_vm.user));
                            }
                            _vm.$alert(r.msg, '提示', {
                                type:'warning',
                                closeOnClickModal:true,
                                closeOnPressEscape:true,
                                confirmButtonText: '确定',
                                callback: action => {
                                    
                                }
                            });
                            console.error('send auth error.');
                            return;
                        } else {
                            _vm.$message({
                                type: 'success',
                                message: '已发送申请'
                            });
                            if(p) {
                                _vm.showApplyComment = 2;
                                _vm.user.commentAuth = 2;
                            } else {
                                _vm.showApplyPost = 2;
                                _vm.user.postAuth = 2;
                            }
                            localStorage.setItem('user', JSON.stringify(_vm.user));
                        }
                    }
                });
            }).catch(() => {

            });
        },
        // 帖子评论查看
        checkComment(postId) {
            // console.log(postId)
            this.dialogTableVisible = true;
            var _vm = this;
            // 获取帖子评论
            $.get(_vm.serveHost + "/api/v1/mainpost/comments/" + postId, function(r){
                if(r.code != "2000000") {
                    console.error('get comments error.');
                    return;
                } 
                console.log(r);
                _vm.commentList = r.data;
            });
        },
        // 帖子删除
        delPost(postId) {
            var _vm = this;
            this.$confirm('此操作将永久删除该帖，是否继续？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(()=>{
                $.ajax({
                    type:'POST',
                    url: _vm.serveHost + "/api/v1/post/mainpost/del/",
                    data: {
                        userId: _vm.user.userid,
                        mainPostId: postId
                    },
                    headers:{
                        Authorization:localStorage.getItem('token')
                    },
                    success: function (res) {
                        _vm.postList.forEach((item, index) => {
                            if(item.id == postId) {
                                // console.log(index);
                                // 把已删除的item删掉
                                _vm.postShow[index] = false;
                                // 触发更新
                                _vm.postList[index].title = "";
                            }
                        });
                        _vm.$message({
                            type: 'success',
                            message: '删除成功'
                        });
                    }
                });
            }).catch(()=>{
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        loadMoreArticle:function() {
            // 我的帖子列表更多加载
            this.pagNo++
            this.loadArticleList(this, this.pagNo, true);
        },
        loadDataByAsync:function(URL, DATA, CALLBACK_FUNC) {
            $.get(URL, DATA, CALLBACK_FUNC);
        },
        loadArticleList:function(_vm, pagNo, isShow) {
            this.loadDataByAsync(_vm.serveHost + "/api/v1/user/mainpost/" + _vm.user.userid + "/" + _vm.pagNo, function(r){
                // console.log(r);
                // if(r.code != "2000000") {
                //     console.error('get mainpost error.');
                //     _vm.hasnotArticle(_vm);
                //     return;
                // }
                // console.log(r.data);
                if(r.data) {
                    r.data.forEach((item, index) => {
                        _vm.postList.push(item);
                        _vm.postShow.push(true);
                    });
                    _vm.hasMoreArticle = true;
                } else {
                    if(isShow) {
                        _vm.hasnotArticle(_vm);
                    }
                }
            });
        },
        hasnotArticle(_vm) {
            _vm.hasMoreArticle = false;
            _vm.$alert('没有更多帖子了', '提示', {
                type:'warning',
                closeOnClickModal:true,
                closeOnPressEscape:true,
                confirmButtonText: '确定',
                callback: action => {
                    
                }
            });
        },
        cancelReply(event) {
            $(event.target).parents('.reply-form').fadeOut(.3);
            this.replyText = '';
        },
        // 回复
        confirmReply(event) {
            // let t = this.$route.query.t;
            var _vm = this;
            var index = event.target.dataset.index;
            var toUid = event.target.dataset.touid;
            var toNickname = event.target.dataset.tonickname;
            var commentId = event.target.dataset.commentid;
            var articleid = event.target.dataset.articleid;
            var replyType = event.target.dataset.replytype;
            var replyId = replyType === '1'? commentId : articleid;
            let url = "";
            let d = {};
            $(event.target).parents('.reply-form').fadeOut(.3);
            // 帖子回复
            url = _vm.serveHost + "/api/v1/post/comments/commit";
            d = {
                postId:_vm.$route.params.article_id,
                fromId:_vm.user.userid,
                content:_vm.commentText,
                nickname:_vm.user.nickName,
                thumbImg:_vm.user.avatar
            };

            $.ajax({
                type:'POST',
                url: url,
                data: d,
                headers:{
                    Authorization:localStorage.getItem('token')
                },
                success:function(r) {
                    // console.log(r);
                    if(r.code != "2000000") {
                        if(_vm.user) {
                            _vm.$message({
                                message:'无回复权，请先申请',
                                type:'error'
                            });
                        } else {
                            _vm.$message({
                                message:'评论失败，请重新登录',
                                type:'error'
                            });
                        }
                        _vm.replyText = '';
                    } else {
                        _vm.$message({
                            message:'发表成功',
                            type:'success'
                        })
                        _vm.commentList[index].replays.push(r.data.replays[0]);
                    }
                }
            });
        },
        commentPraise:function() {

        },
        commentReply:function(event) {
            // $(event.target).parents('.reply-form').fadeOut();
            let dis = $(event.target).parent().siblings('.reply-form').css('display');
            // console.log(dis);
            // console.log(event.target);
            if(dis === 'none') {
                $(event.target).parent().siblings('.reply-form').fadeIn(.3).css('display', 'block');
            } else {
                $(event.target).parent().siblings('.reply-form').fadeOut(.3).css('display', 'none');
            }
        },
        commentTread:function() {
            
        }
    },
    created() {
        var _vm = this;
        this.user = JSON.parse(localStorage.user)
        this.showApplyPost = this.user.postAuth;
        this.showApplyComment = this.user.commentAuth;
        this.loadArticleList(this, this.pagNo, false);
    }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.postOperation:hover, .postOperation:hover div span {
    cursor: pointer;
    color:#409EFF;
}
.postTitle {
    color:#303133;
    font-weight:bold;
    font-size:1.2rem;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display:inline-block;
    width:50%;
}
.postContent {
    color:#606266;
    font-size:.8rem;
}
.empty-data {
    margin: 0 auto;
    padding: 50px;
    color: rgba(0,0,0,.32);
    font-size: 14px;
    line-height: 22px;
    text-align: center;
}
.bbt-subtab__menu li {
    display: inline-block;
    font-size: 12px;
    line-height: 20px;
    color: rgba(0,0,0,.56);
    text-align: center;
    padding: 3px 12px;
    border: 1px solid rgba(0,0,0,.1);
    border-radius: 14px;
    margin-right: 14px;
    margin-bottom: 12px;
    cursor: pointer;
    transition: all .3s ease;
}

.bbt-subtab__menu li.active {
    background: #f46300;
    border-color: #f46300;
    color: #fff;
}
.bbt-subtab__menu.down {
    height: 36px;
    transition: all .3s ease;
}

.bbt-subtab__menu {
    padding-left: 84px;
    padding: 0;
    list-style-type: none;
    overflow: hidden;
}


</style>